import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
// import classnames from 'classnames'
import _ from 'lodash'

import { Chips } from 'gdpp-components/dist/cjs/components/atoms'
import { getCustomIntl, getGlobalParams } from 'config/config'

import StickyContainer from '../../atoms/StickyContainer'

import './style.scss'

const ShoppingCart = ({ storageType, storageKey, maxCartItemsCount }) => {
  const { funds2CartJob, cart2FundJob, baseUrl } = getGlobalParams()
  const { funds2CartSubject } = funds2CartJob
  const { cart2FundTrigger } = cart2FundJob
  const [cartItems, setCartItems] = useState([])
  const [compareUrl, setCompareUrl] = useState()
  const storageInstance = storageType === 'session' ? sessionStorage : localStorage

  const cartItemsRef = useRef(cartItems)

  const setCartItemsRef = (x) => {
    cartItemsRef.current = x
    setCartItems(x)
  }

  const intl = getCustomIntl()

  const getCompareUrl = (currentCartItems) => {
    const compareFundsStr = `${baseUrl}/funds/compare${
      !_.isEmpty(currentCartItems) ? `?scIds=${currentCartItems.map((item) => item.shareClassId).join(',')}` : ''
    }`

    setCompareUrl(compareFundsStr)
  }

  const removeCartItem = (cartItem) => {
    const copiedCartItems = _.clone(cartItemsRef.current)

    _.remove(copiedCartItems, (item) => item.shareClassId === cartItem.shareClassId)
    storageInstance.setItem(storageKey, JSON.stringify(copiedCartItems))

    cart2FundTrigger(copiedCartItems)
    getCompareUrl(copiedCartItems)
    setCartItemsRef(copiedCartItems)
  }

  const clearCart = () => {
    storageInstance.setItem(storageKey, JSON.stringify([]))
    cart2FundTrigger([])
    getCompareUrl([])
    setCartItemsRef([])
  }

  useEffect(() => {
    funds2CartSubject.subscribe({
      next: (items) => {
        getCompareUrl(items)
        setCartItemsRef(items)
      }
    })
  }, [])

  return (
    <StickyContainer
      isOpen={!!cartItemsRef.current.length}
      collapsable
      collapseContent={{
        open: intl.formatMessage({ id: 'fundComparison.shoppingCart.open' }),
        close: intl.formatMessage({ id: 'fundComparison.shoppingCart.close' })
      }}
      containerHeader={intl.formatMessage(
        { id: 'fundComparison.shoppingCart.header' },
        { count: `${cartItemsRef.current.length}/${maxCartItemsCount}` }
      )}
      hasCloseIcon={false}
      confirmLabel={intl.formatMessage({ id: 'fundComparison.shoppingCart.confirmLabel' })}
      cancelLabel={intl.formatMessage({ id: 'fundComparison.shoppingCart.cancelLabel' })}
      clearLabel={intl.formatMessage({ id: 'fundComparison.shoppingCart.clear' })}
      onCancel={clearCart}
      extraClasses="fil-fund--comparison-shopping-cart"
      confirmUrl={compareUrl}
    >
      <div className="fil-fund--comparison-shopping-cart-items">
        {cartItemsRef.current.map((cartItem, cartItemIndex) => (
          <Chips
            key={`fil-fund--comparison-shopping-cart-item-${cartItemIndex}`}
            borderRadiusStyle="none"
            kind="wireframe"
            value={cartItem.shareClassName}
            onClick={() => {
              removeCartItem(cartItem)
            }}
          />
        ))}
      </div>
    </StickyContainer>
  )
}

ShoppingCart.propTypes = {
  storageType: PropTypes.string.isRequired,
  storageKey: PropTypes.string.isRequired,
  maxCartItemsCount: PropTypes.number
}

ShoppingCart.defaultProps = {
  maxCartItemsCount: 5
}

export default ShoppingCart
